/**
 * Log severity levels for the portal ops logger.
 */
export const LOG_LEVEL = Object.freeze({
    DEBUG: 'debug',
    INFO: 'info',
    WARN: 'warn',
    ERROR: 'error',
});

/** Rank used when filtering by minimum remote/console level. */
export const LOG_LEVEL_RANK = Object.freeze({
    [LOG_LEVEL.DEBUG]: 10,
    [LOG_LEVEL.INFO]: 20,
    [LOG_LEVEL.WARN]: 30,
    [LOG_LEVEL.ERROR]: 40,
});
